
const Footer = () => {
 return (
    <div className="footer">
        {/* "Handball 1964" (https://skfb.ly/o6XX6) by urheilumuseo is licensed under Creative Commons Attribution (http://creativecommons.org/licenses/by/4.0/). */}
    </div>
 )
}

export default Footer;